import React from "react";
import { PATH_PRACTICE } from "../utils/constants";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { ImagePager } from "../components/common/ImagePager";

export default function PracticePage() {
  const practiceImages = [
    {
      src: "/images/start_image_1.jpeg",
      alt: "Ergotherapie Rottweil - Heller Therapieraum mit moderner Therapieliege für neurologische und psychiatrische Behandlungen",
    },
    {
      src: "/images/start_image_6.jpg",
      alt: "Ergotherapie Rottweil - Gem\u00fctlicher Besprechungsraum f\u00fcr vertrauliche Beratungsgespr\u00e4che",
    },
    {
      src: "/images/start_image_3.jpeg",
      alt: "Ergotherapie Rottweil - Gro\u00dfz\u00fcgiger Therapieraum mit Sprossenwand f\u00fcr motorische \u00dcbungen",
    },
  ];

  return (
    <>
      <SEOHelmet page="praxis" pathname={PATH_PRACTICE} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Place",
          "name": "Ergotherapie Rottweil - Praxisräume",
          "description": "Ruhige, reizarme Praxisräume für ergotherapeutische Behandlungen. Ausgestattet mit Sprossenwand, Therapieliege und modernen Therapiematerialien.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Auf dem Wall 29",
            "addressLocality": "Rottweil",
            "postalCode": "78628",
            "addressCountry": "DE"
          },
          "amenityFeature": [
            {
              "@type": "LocationFeatureSpecification",
              "name": "Therapieraum mit Sprossenwand"
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "Besprechungsraum"
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "Moderne Therapiematerialien"
            }
          ]
        })}
      </script>

      <main className="space-y-12 sm:space-y-24">
        <section className="overflow-hidden pt-6" aria-label="Unsere Praxis">
          <div className="mx-auto px-6 lg:px-8">
            <header className="mb-10 sm:mb-14">
              <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
                Unsere Praxis
              </h1>
            </header>

            <div className="grid gap-6 sm:gap-8 lg:grid-cols-2">
              <div>
                <p className="mt-2 text-base leading-7 text-gray-500 dark:text-gray-400 lg:pr-8">
                  Unsere Praxis ist ein Ort der Ruhe und Konzentration, gestaltet für Ihre individuellen Therapiebedürfnisse.
                  Der großzügige, reizarm gestaltete Therapieraum mit Sprossenwand und professioneller Therapieliege bietet den
                  perfekten Rahmen für therapeutische Übungen.
                </p>
                <p className="mt-4 text-base leading-7 text-gray-500 dark:text-gray-400 lg:pr-8">
                  In unserem gemütlich eingerichteten Besprechungsraum schaffen wir eine vertrauensvolle Atmosphäre für persönliche
                  Gespräche und Beratungen.
                </p>
                <p className="mt-4 text-base leading-7 text-gray-500 dark:text-gray-400 lg:pr-8">
                  Modernste Therapiematerialien und bewährte Konzepte ermöglichen es uns, Ihre Therapie optimal auf Ihre persönlichen
                  Bedürfnisse abzustimmen.
                </p>
              </div>

              <ImagePager images={practiceImages} />
            </div>
          </div>
        </section>
      </main>
    </>
  );
}


